import React from "react";

import GoogleAd from "components/GoogleAd";

const DealsHero = () => (
  <div className="min-h-[210px] lg:min-h-[278px] flex items-center w-full">
    <GoogleAd
      className="w-full"
      adPath="/13212770/product/category_hero"
      targeting={{
        "brand-expression": "true",
        "product-category": "deals",
      }}
    />
  </div>
);

export default DealsHero;
